import { useCallback, useEffect, useRef, useState } from 'react';
import {
  checkAuth,
  getAuthUser,
  refreshSession,
  signOut,
  redirectToSignIn,
  shouldRefreshSession,
  getSessionTime,
  SESSION_CHECK_INTERVAL_SEC
} from '../../utils';
import { Layout } from '../';

export const App = () => {
  const timeoutRef = useRef(null);
  const [authUser, setAuthUser] = useState(null);

  const scheduleNextCheck = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    const minutes = getSessionTime();

    if (!minutes) {
      return;
    }

    timeoutRef.current = window.setTimeout(async () => {
      if (!checkAuth()) {
        console.error('Check Auth... failed');
        signOut();

        return;
      }

      if (shouldRefreshSession()) {
        try {
          await refreshSession();

        } catch (error) {
          console.error('Failed to refresh session:', error);
          signOut();

          return;
        }
      }

      scheduleNextCheck();
    }, SESSION_CHECK_INTERVAL_SEC);
  }, []);

  const startSessionCheck = useCallback(() => {
    refreshSession().then(() => {
      scheduleNextCheck();
    }).catch(error => {
      console.error('Failed to initialize session:', error);
      signOut();
    });
  }, [scheduleNextCheck]);

  const checkLoggedIn = useCallback(() => {
    if (!checkAuth()) {
      redirectToSignIn();

    } else {
      startSessionCheck();
      setAuthUser(getAuthUser());
    }
  }, [startSessionCheck]);

  useEffect(() => {
    checkLoggedIn();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [checkLoggedIn]);

  if (!authUser) {
    return null;
  }

  return <Layout />;
};

export default App;
